import { FormControl } from '@angular/forms';
import { Nullable } from '@core/helpers/nullable';

export enum RequestDeviceProtectiveCaseFormFields {
  HasProtectiveCase = 'hasProtectCase',
  ProtectiveCaseNumber = 'protectCaseNumber',
}

export type ProtectiveCaseFormControl = FormControl<null | {
  [RequestDeviceProtectiveCaseFormFields.HasProtectiveCase]: boolean;
  [RequestDeviceProtectiveCaseFormFields.ProtectiveCaseNumber]: Nullable<number>;
}>;
